var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'show':_vm.show},attrs:{"id":"snackbar"}},[_c('img',{attrs:{"src":("/img/covid-test/" + _vm.icon + ".svg"),"alt":"icon"}}),_vm._v("\n  "+_vm._s(_vm.message)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }